<div class="truck-overview-action-bar">
  <div class="group">
    <div class="buttons">
      <sc-button mat-icon-button (click)="registerTruck()"
      dictionaryKey="tmc.visit.overview.trucks.action.register">
        <sc-icon iconClass="fa-plus"></sc-icon>
      </sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button mat-icon-button (click)="editTruck()" [disabled]="!editTruckEnabled"
        dictionaryKey="tmc.visit.overview.trucks.action.edit">
        <sc-icon iconClass="fa-edit"></sc-icon>
      </sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button mat-icon-button (click)="leave()"
        dictionaryKey="tmc.visit.overview.trucks.action.leave"
        [disabled]="!leaveTruckEnabled">
        <sc-icon iconClass="fa-door-closed"></sc-icon>
      </sc-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button mat-icon-button (click)="showGcCase()" [disabled]="!showGcCaseEnabled"
        *ngIf="configurationService.isPropertyTrue('feature.globalconnect', true)"
        dictionaryKey="tmc.visit.overview.action.showGcCase">
        <sc-icon iconClass="fa-mobile-android-alt"></sc-icon>
      </sc-button>
    </div>
  </div>
</div>
